export function addRaptorCustomError(name, msg, tags, level = 'info') {
  try {
    window.Owl?.addError(
      {
        name,
        msg,
      },
      {
        combo: true,
        level,
        category: 'customError',
        tags,
      },
    );
  } catch (error) {
    console.info(error);
  }
}
